import apiService from "./api";

const labelService = {
  getLabels() {
    return apiService.get("/labels");
  },
};

export default labelService;
